// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import constants from "@store/constants";
import getOnClickHistoryBack from "@store/Framework/Common/Utilities/getOnClickHistoryBack";
import { useInvoicePaymentContext } from "@store/Framework/Components/InvoicePaymentContext/InvoicePaymentContext";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, ReactNode } from "react";

export interface InvoicePaymentHeaderProps extends WidgetProps {}

export interface InvoicePaymentHeaderStyles {
    errorInfosBox?: InfosBoxProps;
    successInfosBox?: InfosBoxProps;
    warningInfosBox?: InfosBoxProps;
}

export const invoicePaymentHeaderStyles: InvoicePaymentHeaderStyles = {
    errorInfosBox: { type: "error" },
    successInfosBox: { type: "success" },
    warningInfosBox: { type: "warning" },
};

const styles = invoicePaymentHeaderStyles;

const InvoicePaymentHeader: FC<InvoicePaymentHeaderProps> = () => {
    const currentPage = useCurrentPage();
    const { errorMessage, invalidInvoiceIds, isLoading, paymentErrorMessage, paymentSuccess } =
        useInvoicePaymentContext();

    const linkBack = usePageLinkByPageType(constants.pageType.invoiceHistory);
    const linkBackOnClick = getOnClickHistoryBack(linkBack);

    let message: ReactNode;
    if (!isLoading) {
        if (errorMessage) {
            message = <InfosBox {...styles.errorInfosBox}>{errorMessage}</InfosBox>;
        } else {
            const isPaymentError = Boolean(paymentErrorMessage);
            const isPaymentSuccess = Boolean(paymentSuccess);

            if (isPaymentSuccess) {
                message = (
                    <InfosBox {...styles.successInfosBox}>
                        {translate("grimco_invoiceHistory_paymentConfirmation_base")}
                    </InfosBox>
                );
            }

            if (isPaymentError) {
                message = <InfosBox {...styles.errorInfosBox}>{paymentErrorMessage}</InfosBox>;
            }

            if (!isPaymentSuccess && !isPaymentError && Boolean(invalidInvoiceIds.length)) {
                const invoiceIdsForMessage = invalidInvoiceIds.map(x => `"${x}"`).join(", ");
                message = (
                    <InfosBox {...styles.warningInfosBox}>
                        {invalidInvoiceIds.length === 1
                            ? translate(
                                  `Selected invoice {0} was excluded from the current payment because it does not exist or has already been paid.`,
                                  invoiceIdsForMessage,
                              )
                            : translate(
                                  `Selected invoices {0} were excluded from the current payment because they do not exist or have already been paid.`,
                                  invoiceIdsForMessage,
                              )}
                    </InfosBox>
                );
            }
        }
    }

    return (
        <OrderHeader
            id="invoice-payment-header"
            title={currentPage.fields.title}
            linkBack={linkBack}
            linkBackOnClick={linkBackOnClick}
            message={message}
        />
    );
};

const widgetModule: WidgetModule = {
    component: InvoicePaymentHeader,
    definition: {
        group: constants.widgetGroup.invoicePayment,
        displayName: "Header",
        allowedContexts: [constants.pageType.invoicePayment],
        fieldDefinitions: [],
    },
};

export default widgetModule;
